import { Component, ElementRef, OnInit, ViewChild } from "@angular/core";
import {
  FormArray,
  FormBuilder,
  FormControl,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from "@angular/forms";
import { MatDialog } from "@angular/material/dialog";
import { ActivatedRoute, Router } from "@angular/router";
import { FileUploader } from "ng2-file-upload";
import { DialogOverviewExampleDialogComponent } from "../../../dialog-overview-example-dialog/dialog-overview-example-dialog.component";
import { BackendApiService } from "../../../../app/services/backend-api.service";
import { BaseUrlConstantsService } from "../../../../app/services/base-url-constants.service";
import { PowerTrainService } from "../../../../app/services/powertrain.service";
import { v4 as uuid } from "uuid";
import { NgxSpinnerModule, NgxSpinnerService } from "ngx-spinner";
import { MatRadioModule } from "@angular/material/radio";
import { CommonModule, DatePipe } from "@angular/common";
import { MatAutocomplete, MatAutocompleteModule, MatOption } from "@angular/material/autocomplete";
import { MatButtonModule } from "@angular/material/button";
import { DeviceTemplateComponent } from "../../../device-template/device-template.component";
import { MatIconModule } from "@angular/material/icon";


@Component({
  selector: "app-create-powertrain-form",
  templateUrl: "./create-powertrain-form.component.html",
  styleUrls: ["./create-powertrain-form.component.scss"],
  standalone: true,
  imports:[MatRadioModule,FormsModule,NgxSpinnerModule,CommonModule,ReactiveFormsModule,MatAutocomplete,MatOption,MatAutocompleteModule,MatIconModule,DeviceTemplateComponent],
  providers: [{ provide: DatePipe, useValue: new DatePipe('en-US') },FormControl],
})
export class CreatePowertrainFormComponent implements OnInit {
  @ViewChild("divToScroll") divToScroll: ElementRef;
  // URLS
  public allSitesUrl = BaseUrlConstantsService.GET_SITES;
  public assetsBearingUrl = BaseUrlConstantsService.ASSETS_BEARING;
  public createBearingNumberUrl = BaseUrlConstantsService.ASSETS_CREATE_BEARING;
  public updateAssetsUrl = BaseUrlConstantsService.UPDATE_ASSETS;
  public clientDeviceUrl = BaseUrlConstantsService.CLIENT_DEVICES;
  public deviceTypeUrl = BaseUrlConstantsService.DEVICE_TYPE;
  public addAssetsUrl = BaseUrlConstantsService.ADD_ASSETS;
  public addPowertrain = BaseUrlConstantsService.POWERTRAIN_ADD_POWERTRAIN;
  updatePositionurl = BaseUrlConstantsService.POWERTRAIN_UPDATE_POSITIONS_URL;

  gearDetailForm: Boolean;
  editable = false;
  assetDetailForm: Boolean;
  selectedAssetTypeRadio = "INDUCTION_MOTOR";

  showEditUsertxt = "Create Asset";
  private showSavebtn: boolean = false;
  currentSensorIndex = -1;
  powertrainSensors = [];
  currentSensor = [];
  subAssetType = "";
  options=[];//ODR ODR HIGH OPTIONS ARRAY

  uForm: any;
  sitesList = [];
  applications = [];
  userID: string;
  adminID: string;

  public insertClass = ["A", "B", "F", "H"];
  public bearingNumbers: any = [];
  public beltData: any = [];

  public driveType: string = "DIRECT";
  public driveVisibility: boolean;

  //DEVICE CONFIGURATION GROUP VARIABLES
  public assetStatus: number = 1;
  public isItAccelroDevice: boolean = false;
  private count = 0;
  private AdvanceSetting: boolean = false;

  //OTHER CONFIGURATION
  private tempValuesArr: number[] = [];

  //CONNECTIVITY CONFIGURATION
  public connectionInput: boolean = true;
  public connectionInputProxy: boolean;

  //Bearing Number Configuration
  public valuebearing: any = "on";
  public outputbearingVal: any = "yes";

  //Mac address and serial number
  public allDevices: any;
  public filterdOptions = [];
  public ivInventoryMsg: any = "";
  public connectedMacAddress: any;
  public deviceTypeID: any;
  public InventoryIDValue: any = "";

  //RATED RPM
  public variableRPMToggle: string = "fixed";

  //Save button
  public showDisabledSaveBtn: boolean;
  public showEnabledSaveBtn = true;
  public createAssetEnabled = true;
  public fromDataArray: any = [];
  public uploader: FileUploader;
  public percentDone = 0;
  public pic: any = false;
  public assetsID: any;
  public uploadSuccess: boolean;
  public id: any;
  public _imageId = null;
  public invalidFrequencyValue: boolean;
  public selectedAssetType: string = "MOTOR";
  public onOffStatus: string = "";
  public currentFormCount: any = 0;
  public totalSensors = 0;

  //gear
  public GMFvisible = false;

  //IMAGE UPLAOD
  public fileName = "";
  public showCancelBtn: boolean;
  public imagePath;
  public _imgUrl: any;

  //Subsystem table data
  subsystem_table_data: any = {};
  isPowertrain: boolean = false;
  assetPositionJson: any = {};
  currentSensorIndexForAssetId: any = 0;

  constructor(
    private formBuilder: FormBuilder,
    private service: BackendApiService,
    public dialog: MatDialog,
    public route: ActivatedRoute,
    public router: Router,
    private powertrainService: PowerTrainService,
    private spinner: NgxSpinnerService,
  ) {
    localStorage.setItem("assetBatchID", uuid());
  }

  ngOnInit(): void {
    this.getBeltInfo();
    this.setUserId();
    this.createFormInitially();
    this.setTemperatureValues();
    this.route.queryParams.subscribe((params) => {
      console.log(params);
      if (params["type"] == "PowertrainUpdate") {
        console.log("In if block");
        this.showEditUsertxt = "Update Powertrain";
        this.isPowertrain = true;
        this.subsystem_table_data = JSON.parse(
          decodeURIComponent(params["subsytemTableData"])
        );
        console.log(this.subsystem_table_data);
        const canvasItems = JSON.parse(decodeURIComponent(params["data"]));
        console.log(canvasItems);
        this.powertrainSensors = canvasItems;
        this.totalSensors = canvasItems.length;
        this.currentSensorIndex = params["newIndex"];
        this.currentSensorIndexForAssetId = params["newIndex"];
        console.log("CURRENT INDEX" + this.currentSensorIndex);
        this.selectedAssetType =
          this.powertrainSensors[this.currentSensorIndex].assetType;

        // SET INITIAL FORM
        if (this.selectedAssetType == "GEAR") {
          this.gearDetailForm = true;
          this.assetDetailForm = false;
          this.selectedAssetTypeRadio = "GEAR";
          this.gearFormController();
          this.subAssetType = "";
        } else if (this.selectedAssetType == "MOTOR") {
          this.gearDetailForm = false;
          this.assetDetailForm = true;
          this.selectedAssetTypeRadio =
            this.powertrainSensors[this.currentSensorIndex].subType;
          this.subAssetType =
            this.powertrainSensors[this.currentSensorIndex].subType;
        } else {
          this.subAssetType = "";
          this.gearDetailForm = false;
          this.assetDetailForm = true;
          this.selectedAssetTypeRadio =
            this.powertrainSensors[this.currentSensorIndex].assetType;
        }
        console.log("Total Sensors: " + this.totalSensors);
        console.log("Current Sensor: " + this.currentSensorIndex);
        console.log("Current Sensor: " + this.currentSensorIndex + 1);
        if (this.totalSensors == Number(this.currentSensorIndex) + 1) {
          this.showSavebtn = true;
          console.log(this.showSavebtn);
        } else {
          //show continue button
          console.log(this.showSavebtn);
          this.showSavebtn = false;
        }
      } else {
        this.showEditUsertxt = params["type"];
        if (params["assetType"] == "powertrain") {
          this.isPowertrain = true;
        } else {
          this.isPowertrain = false;
          this.assetPositionJson = JSON.parse(
            decodeURIComponent(params["jsonData"])
          );
        }
        this.subsystem_table_data = JSON.parse(
          decodeURIComponent(params["subsytemTableData"])
        );
        if (params["data"]) {
          const canvasItems = JSON.parse(decodeURIComponent(params["data"]));
          this.powertrainSensors = canvasItems;
          //set total sensors count to show continue or save asset button
          this.totalSensors = canvasItems.length;
          this.currentSensorIndex = 0;
          console.log(this.powertrainSensors);
          this.selectedAssetType =
            this.powertrainSensors[this.currentSensorIndex].assetType;
          if (this.selectedAssetType == "GEAR") {
            this.gearDetailForm = true;
            this.assetDetailForm = false;
            this.selectedAssetTypeRadio = "GEAR";
            this.gearFormController();
            this.subAssetType = "";
          } else if (this.selectedAssetType == "MOTOR") {
            this.gearDetailForm = false;
            this.assetDetailForm = true;
            this.selectedAssetTypeRadio =
              this.powertrainSensors[this.currentSensorIndex].subType;
            this.subAssetType =
              this.powertrainSensors[this.currentSensorIndex].subType;
          } else {
            this.subAssetType = "";
            this.gearDetailForm = false;
            this.assetDetailForm = true;
            this.selectedAssetTypeRadio =
              this.powertrainSensors[this.currentSensorIndex].assetType;
          }
          //If only one sensor was added while creating powertrain make save button else make continue button
          if (this.totalSensors == 1) {
            this.showSavebtn = true;
          } else {
            //show continue button
            this.showSavebtn = false;
          }
        }
      }
    });
  }

  setUserId() {
    switch (localStorage.getItem("role")) {
      case "ACCOUNT_MANAGER":
        this.userID = localStorage.getItem("admin_client_id");
        break;
      case "USER":
        this.userID = localStorage.getItem("associated_clientid");
        break;
      case "ADMIN":
        this.userID = localStorage.getItem("admin_client_id");
        break;
      case "CLIENT":
        this.userID = localStorage.getItem("user_id");
        this.adminID = localStorage.getItem("associated_clientid");
        break;
      default:
        //
        break;
    }
    //After setting userId fetch user sites and applications
    this.getallSitesAndGroupsInfo();
    this.getallBearing();
    this.getallDevices();
  }

  createFormInitially() {
    this.uForm = this.formBuilder.group({
      cloud_pushrate_high: new FormControl(60, [Validators.required]),
      cloud_pushrate_anomaly: new FormControl(180, [Validators.required]),
      cloud_anomaly_counter: new FormControl(1, [Validators.required]),
      Axial: new FormControl(1, [Validators.required]),
      Horizontal: new FormControl(1, [Validators.required]),
      Vertical: new FormControl(1, [Validators.required]),
      accelro_odr_high: new FormControl("NORMAL"),
      accelro_odr: new FormControl("NORMAL"),
      motor_make: new FormControl(""),
      equipment_location: new FormControl(""),
      line_current: new FormControl("0"),
      frame: new FormControl(""),
      device_name: new FormControl("", [
        Validators.required,
        // this.noWhitespaceValidator,
      ]),
      rated_ambient_temprature: new FormControl("0"),
      insulation_class: new FormControl("", [Validators.required]),
      motor_serial: new FormControl("", [
        Validators.required,
        // this.noWhitespaceValidator,
      ]),
      rated_power: new FormControl("", [Validators.required]),
      rated_rpm: new FormControl("", Validators.required),
      max_rated_rpm: new FormControl(""),
      min_rated_rpm: new FormControl(""),
      rpm_toggle: new FormControl("fixed"),
      rated_voltage: new FormControl(""),
      power_factor: new FormControl(""),
      temperature_sy: new FormControl(""),
      power_unit: new FormControl("KW"),
      GMF_unit: new FormControl("no"),
      site_id: new FormControl("KW"),
      site_id_val: new FormControl(""),
      application_id_name: new FormControl(""),
      application_id: new FormControl("", Validators.required),
      mac_address: new FormControl("", Validators.required),
      duty: new FormControl(""),
      percentage_efficiency: new FormControl(""),
      line_frequency: new FormControl("", [Validators.required]),
      data_frequency: new FormControl(15, [Validators.required]),
      config_pull_rate: new FormControl(60),
      cloud_push_rate: new FormControl(60),
      sensor_scan_rate: new FormControl(15),
      file_comparison_threshold_percentage: new FormControl(60),
      winding_rtd: new FormControl("0"),
      connectivity_type: new FormControl("wifi"),
      wifi_user: new FormControl("EnerticsWiFi", [Validators.required]),
      wifi_password: new FormControl("enertics"),
      ip: new FormControl(""),
      port: new FormControl(""),
      proxy_username: new FormControl(""),
      proxy_password: new FormControl(""),
      name: new FormControl("", [
        Validators.required,
        // this.noWhitespaceValidator,
      ]),
      de_bearing_number: new FormControl("NA"),
      nde_bearing_number: new FormControl("NA"),
      nde_bearing: new FormControl("0"),
      de_bearing: new FormControl("0"),
      device_config_update_interval: new FormControl(60),
      vs_scan_rate: new FormControl(15, [Validators.required]),
      machine_threshold_status: new FormControl(0.5, [Validators.required]),
      accelero_FS: new FormControl(8, [Validators.required]),
      vs_resolution_mode: new FormControl("NORMAL"),

      sensor_mounting_axis_option: new FormControl("PARALLEL_SIDE"),
      rtd_one: new FormControl("MS"),
      rtd_two: new FormControl("DE"),
      rtd_three: new FormControl("NDE"),
      belt_length: new FormControl(""),
      belt_number: new FormControl(""),
      db_shart_centers: new FormControl(""),
      driven_pulley_diameter: new FormControl(""),
      driver_pulley_diameter: new FormControl(""),
      outer_bearing_no: this.formBuilder.array([]),
      gmf_data: this.formBuilder.array([]),
      drive_type: new FormControl(""),
      no_of_blades: new FormControl(1),
      bearing_radio: new FormControl("off"),
      output_bearing_radio: new FormControl("yes"),
      audible_adjustment: new FormControl([0]),
      polePairNumber: new FormControl([0]),
      dc_type: new FormControl(""),
    });

    //Initially always disable while creating for mfor first time for every type of asset
    this.uForm.get("de_bearing_number").disable();
    this.uForm.get("nde_bearing_number").disable();

    this.options = [
      { value: "HIGH", label: "High (Fₘₐₓ = 3400Hz)"},
      { value: "NORMAL", label: "Normal (Fₘₐₓ = 1700Hz)"},
      { value: "LOW", label: "Low (Fₘₐₓ = 200Hz)"},
      { value: "EXTRALOW", label: "Extra Low (Fₘₐₓ = 100Hz)"},
      { value: "EXTRAEXTRALOW", label: "Extra Extra Low (Fₘₐₓ = 50Hz)"},
      {value: "UltraLow", label: "Ultra Low"},
      {value: "UltraUltraLow", label: "Ultra Ultra Low"}
    ];

  }

  getallSitesAndGroupsInfo() {
    let url =
      this.allSitesUrl +
      "/" +
      Math.floor(Math.random() * 90 + 10) +
      this.userID +
      Math.floor(Math.random() * 9000 + 1000);

    this.service.getData(url).then((res) => {
      let response = JSON.parse(JSON.stringify(res));
      if (response.data.status === "success") {
        if (response.data.length !== 0) {
          this.sitesList = response.data.body;
          if (this.sitesList.length !== 0) {
          }
        }
      } else {
        this.service.showError("Something went wrong.");
      }
    });
    console.log(this.sitesList);
  }

  selectSite(siteValue) {
    console.log("siteValue" + siteValue);
    if (this.sitesList.length !== 0) {
      // console.log(this.sitesList);
      const dataF = this.sitesList.filter(
        (result) => result.id === parseInt(siteValue)
      );
      console.log(dataF, "dataFFFF");
      let application = dataF[0].applications[0].id;
      this.uForm.controls["application_id"].setValue(application);
      this.applications = dataF[0].applications;
    }
  }

  //BEARING NUMBER FUNCTIONS
  getallBearing() {
    this.service.getData(this.assetsBearingUrl).then((res) => {
      let response = JSON.parse(JSON.stringify(res));
      if (response.data.status === "success") {
        let result = response.data.body;
        // this.bearingNumbers = result.slice(0, 1000);
        // this.bearingNumbers = [
        //   ...this.bearingNumbers,
        //   result.slice(1001, result.length - 1),
        // ];
        // this.bearingNumbers=[{bearing_number:"N/A"},...this.bearingNumbers]
        this.bearingNumbers = result;
      } else {
        this.service.showError("Something went wrong.");
      }
    });
  }

  bearingButton(value: any, type, isFirstTime: boolean = false) {
    //  on off means is ball bearing selected or not
    this.valuebearing = value;
    if (type == "GEAR") {
      if (value == "on") {
        this.uForm.get("deb_pinion_number").enable();
        this.uForm.get("ndeb_pinion_number").enable();
        if (isFirstTime == false) {
          this.uForm.patchValue({
            deb_pinion_number: this.bearingNumbers[2].bearing_number,
            ndeb_pinion_number: this.bearingNumbers[2].bearing_number,
          });
        }
      } else {
        this.uForm.patchValue({
          deb_pinion_number: this.bearingNumbers[0].bearing_number,
          ndeb_pinion_number: this.bearingNumbers[0].bearing_number,
        });
        this.uForm.get("deb_pinion_number").disable();
        this.uForm.get("ndeb_pinion_number").disable();
      }
    } else {
      if (value == "on") {
        this.uForm.patchValue({
          de_bearing_number: this.bearingNumbers[2].bearing_number,
          nde_bearing_number: this.bearingNumbers[2].bearing_number,
        });
        this.uForm.get("de_bearing_number").enable();
        this.uForm.get("nde_bearing_number").enable();
      } else {
        this.uForm.patchValue({
          de_bearing_number: this.bearingNumbers[0].bearing_number,
          nde_bearing_number: this.bearingNumbers[0].bearing_number,
        });
        this.uForm.get("de_bearing_number").disable();
        this.uForm.get("nde_bearing_number").disable();
      }
    }
  }

  getBeltInfo() {
    this.service.getData(this.updateAssetsUrl + "/belt/all").then((res) => {
      let response = JSON.parse(JSON.stringify(res));
      if (response.data.status === "fail") {
        const msgErr = response.data.body.message;
        this.service.showError(msgErr);
      } else if (response.data.status === "success") {
        this.beltData = response.data.body;
      } else {
        this.service.showError("Something went wrong.");
      }
    });
  }

  // ----------------------------------------------------------------DIALOG BOX COMPONETS----------------------------------------------------------------
  addNewBearing() {
    const dialogRef = this.dialog.open(DialogOverviewExampleDialogComponent, {
      width: "300px",
      maxWidth: "100%",
      data: {
        type: "DialogForBearingNumber",
        data: {},
      },
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result !== undefined) {
        if (result.data.bearing_number == undefined) {
          this.service.showError("Bearing inputs can't be empty!");
        } else if (result.data.bbf == undefined) {
          this.service.showError("Bearing inputs can't be empty!");
        } else if (result.data.bcf == undefined) {
          this.service.showError("Bearing inputs can't be empty!");
        } else if (result.data.irf == undefined) {
          this.service.showError("Bearing inputs can't be empty!");
        } else if (result.data.orf == undefined) {
          this.service.showError("Bearing inputs can't be empty!");
        } else {
          let body = {
            bbf: result.data.bbf,
            bcf: result.data.bcf,
            bearing_number: result.data.bearing_number,
            irf: result.data.irf,
            orf: result.data.orf,
          };
          this.service
            .postData(this.createBearingNumberUrl, body)
            .then((res) => {
              if (JSON.parse(JSON.stringify(res)).data.status === "error") {
                this.service.showError("Bearing number already exist.");
              } else if (
                JSON.parse(JSON.stringify(res)).data.status === "success"
              ) {
                this.service.showSuccess("New bearing added successfully.");
                this.getallBearing();
              }
            });
        }
      } else {
      }
    });
  }

  addNewBeltNumber() {
    const dialogRef = this.dialog.open(DialogOverviewExampleDialogComponent, {
      width: "300px",
      maxWidth: "100%",
      data: {
        type: "DialogForBeltNumber",
        data: {},
      },
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result !== undefined) {
        if (Object.keys(result).length !== 0) {
          if (result.data.belt_number === undefined) {
            this.service.showError("Belt number can't be empty!");
          } else if (result.data.belt_length === undefined) {
            this.service.showError("Belt length can't be empty!");
          } else {
            let body = {
              belt_number: result.data.belt_number,
              belt_length: result.data.belt_length,
            };
            this.service
              .postData(this.updateAssetsUrl + "/belt", body)
              .then((res) => {
                if (JSON.parse(JSON.stringify(res)).data.status === "error") {
                  this.service.showError("Belt number already exist.");
                } else if (
                  JSON.parse(JSON.stringify(res)).data.status === "success"
                ) {
                  this.service.showSuccess("New bealt added successfully.");
                  this.getBeltInfo();
                }
              });
          }
        } else {
          this.service.showError("Belt number can't be empty!");
        }
      }
    });
  }

  // ----------------------------------------------------------------DIALOG BOX COMPONETS ENDS----------------------------------------------------------------

  public onDriveChange(selectedValue) {
    console.log(selectedValue);
    if (selectedValue.value != undefined) {
      this.driveType = selectedValue.value;
    } else {
      this.driveType = selectedValue;
    }
    if (this.driveType === "PULLEY") {
      this.driveVisibility = true;
      this.uForm.get("belt_length").setValidators([Validators.required]);
      this.uForm.get("belt_number").setValidators([Validators.required]);
      this.uForm.get("db_shart_centers").setValidators([Validators.required]);
      this.uForm
        .get("driven_pulley_diameter")
        .setValidators([Validators.required]);
      this.uForm
        .get("driver_pulley_diameter")
        .setValidators([Validators.required]);
    } else {
      this.driveVisibility = false;
      this.uForm.get("belt_length") === null
        ? ""
        : this.uForm.get("belt_length").clearValidators();
      //this.uForm.get("belt_length").clearValidators();
      this.uForm.get("belt_number") === null
        ? ""
        : this.uForm.get("belt_number").clearValidators();
      this.uForm.get("db_shart_centers") === null
        ? ""
        : this.uForm.get("db_shart_centers").clearValidators();
      this.uForm.get("driven_pulley_diameter") === null
        ? ""
        : this.uForm.get("driven_pulley_diameter").clearValidators();
      this.uForm.get("driver_pulley_diameter") === null
        ? ""
        : this.uForm.get("driver_pulley_diameter").clearValidators();
      //this.deletePulleyInfo();
    }
  }

  // DEVICE CONFIGURATION
  AdvanceSettings() {
    this.count++;
    if ((this.count = 1)) {
      this.AdvanceSetting = true;
      this.count++;
    } else {
      this.AdvanceSetting = false;
      this.count--;
    }
  }

  //OTHER CONFIGURATION
  get audibleSoundList(): number[] {
    return Array.from({ length: 31 }, (_, i) => i);
  }
  get NumberOfPolePairs(): number[] {
    return Array.from({ length: 9 }, (_, i) => i);
  }

  setTemperatureValues() {
    for (let tV = 0; tV <= 40; tV++) {
      this.tempValuesArr.push(tV);
    }
  }

  // CONNECTIVITY CONFIGURATION
  selectConnectionType(value: string) {
    switch (value) {
      case "wifi":
        this.connectionInput = true;
        this.connectionInputProxy = false;
        this.uForm.get("ip").setValidators();
        this.uForm.get("port").setValidators();
        break;
      case "bluetooth":
        this.connectionInput = false;
        this.connectionInputProxy = false;
        this.uForm.get("ip").setValidators();
        this.uForm.get("port").setValidators();
        break;
      case "cellular":
        this.connectionInput = false;
        this.connectionInputProxy = false;
        this.uForm.get("ip").setValidators();
        this.uForm.get("port").setValidators();
        break;
      case "proxy":
        this.connectionInputProxy = true;
        this.connectionInput = false;
        this.uForm.get("ip").setValidators([Validators.required]);
        this.uForm.get("port").setValidators([Validators.required]);
        break;
    }
  }

  // ------------- FETCH MAC ADDRESS AND SERIAL NUMBER --------------------------------
  getallDevices() {
    this.service
      .getData(
        this.clientDeviceUrl +
          "/" +
          Math.floor(Math.random() * 90 + 10) +
          this.userID +
          Math.floor(Math.random() * 9000 + 1000)
      )
      .then((res) => {
        let response = JSON.parse(JSON.stringify(res));
        if (response.data.status === "success") {
          if (response.data.body.length !== 0) {
            if (response.data.body.body !== undefined) {
              this.allDevices = response.data.body.body;
              this.filterdOptions = this.allDevices;
            } else {
              this.allDevices = response.data.body;
              this.filterdOptions = this.allDevices;
            }
          }
        } else {
          this.service.showError("Something went wrong.");
        }
      });
  }
  filterUsers(value) {
    let tempArr = this.allDevices;
    if (tempArr != undefined) {
      let passed = tempArr.find(
        (item) => item.mac_address.toLowerCase() === value.toLowerCase()
      );
      if (passed === undefined) {
        this.ivInventoryMsg = "Invalid device id.";
      } else {
        this.ivInventoryMsg = "";
      }
      this.filterdOptions = tempArr.filter((item) =>
        item.mac_address
          .toLowerCase()
          .includes(this.uForm.value.mac_address.toLowerCase())
      );
    } else {
      if (this.connectedMacAddress != undefined) {
        if (this.connectedMacAddress.toLowerCase() === value.toLowerCase()) {
          this.ivInventoryMsg = "";
        } else {
          this.ivInventoryMsg = "You don't have assigned device id.";
        }
      } else {
        this.ivInventoryMsg = "You don't have assigned device id.";
      }
    }
  }
  onFilterOptionSelected(optionSelected) {
    let objVal = this.allDevices.filter(
      (x) => x.mac_address === optionSelected
    );
    this.uForm.controls.mac_address.setValue(objVal[0].mac_address);
    this.InventoryIDValue = objVal[0].id;
    this.connectedMacAddress = objVal[0].mac_address;
    this.uForm.controls["motor_serial"].setValue(objVal[0].name);
    this.deviceTypeID = objVal[0].device_type_id;
    this.getDeviceType(this.deviceTypeID);

    this.powertrainSensors[this.currentSensorIndex].device_id = objVal[0].id;
    if (!this.isPowertrain) {
      this.assetPositionJson.map((asset) => {
        asset.sensors.map((sensor) => {
          sensor.sensor_number == this.currentSensorIndex
            ? (sensor.inventory_id = objVal[0].id)
            : "";
          sensor.sensor_number == this.currentSensorIndex
            ? (sensor.motor_serial_no = objVal[0].name)
            : "";
          sensor.sensor_number == this.currentSensorIndex
            ? (sensor.mac_address = objVal[0].mac_address)
            : "";
        });
      });
      console.log(this.assetPositionJson);
    }
  }
  getDeviceType(type_id) {
    this.service
      .getData(this.deviceTypeUrl + "/" + type_id)
      .then((response) => {
        const deviceType = JSON.parse(JSON.stringify(response)).data.body.name;
        if (deviceType.toLowerCase().includes("accelero")) {
          this.isItAccelroDevice = true;
        } else {
          this.isItAccelroDevice = false;
        }
      });
  }

  // RPM TOGGLE
  onRPMChange(selectedValue) {
    this.variableRPMToggle = selectedValue.value;
    this.uForm.controls["max_rated_rpm"].setValue(0);
    this.uForm.controls["min_rated_rpm"].setValue(0);
  }

  //SAVE ASSET
  saveAsstes() {
    console.log("SAVE ASSET")
    if (this.showEditUsertxt === "Create Asset" || "Update Powertrain") {
      console.log("INSIDE IF")
      this.showDisabledSaveBtn = true;
      this.showEnabledSaveBtn = false;
      this.spinner.show();
      this.saveDraft();
      console.log(this.uForm.value);
      console.log(this.powertrainSensors);
      console.log(this.fromDataArray[0]["body"]);
      const sensorsCreationPromises = this.fromDataArray.map((s, index) => {
        return (
          this.service
            .postData(this.addAssetsUrl, this.fromDataArray[index]["body"])
            // .postData("http://localhost:3800/assets", this.fromDataArray[index]["body"])
            .then((res) => {
              let response = JSON.parse(JSON.stringify(res));
              if (response.data.status === "fail") {
                const msgErr = response.data.body.message;
                this.service.showError(msgErr);
                return { success: false, index }; // Mark as failed
              }
              return { success: true, data: response.data };
            })
        );
      });
      Promise.all(sensorsCreationPromises).then((results: any) => {
        this.spinner.hide();
        const hasFailures = results.some((result: any) => !result.success);
        if (hasFailures) {
          this.service.showError(
            // "One or more requests failed. Last API call skipped."
            "Failed to save assets"
          );
          this.showDisabledSaveBtn = false;
          this.showEnabledSaveBtn = true;
          return; // Stop execution if any request failed
        } else {
          if (this.showEditUsertxt == "Update Powertrain") {
            // this.currentSensorIndexForAssetId
            let j = 0;
            this.powertrainSensors.map((sensor, i) => {
              if (i >= this.currentSensorIndexForAssetId)
                sensor.asset_id = results[j++].data.asset_id;
            });
            this.powertrainService
              // "http://localhost:7777/powertrain/powertrain/sensor-postions/" +
              .updateSensorsPosition(
                this.updatePositionurl + this.subsystem_table_data.subsystem_id,
                {
                  subsystem_name: this.subsystem_table_data.subsystem_name,
                  device_position: this.powertrainSensors,
                }
              )
              .then((data) => {
                console.log(data);
                this.router.navigate(["/device-reports"]);
              })
              .catch((err) => {
                console.log(err);
              });
          } else {
            if (this.isPowertrain) {
              this.powertrainSensors.map((sensor, i) => {
                console.log(results[i].data);
                sensor.asset_id = results[i].data.asset_id;
              });
            } else {
            }
            let powerTrainSubsystemData = {
              sensors: this.isPowertrain
                ? this.powertrainSensors
                : this.assetPositionJson,
              subsytemTableData: {
                subsystem_name: this.subsystem_table_data.subsystem_name,
                client_id: this.subsystem_table_data.client_id,
                Image_path: this.subsystem_table_data.Image_path,
                subsystem_uuid: localStorage.getItem('assetBatchID'),
                site_id: localStorage.getItem('siteID'),
                application_id: localStorage.getItem('applicationID'),
                subsystem_type: "powertrain",
              },
            };
            this.service
              .postData(this.addPowertrain, powerTrainSubsystemData)
              // .postData(
              //   "http://localhost:3004/postSubsystemData",
              //   powerTrainSubsystemData
              // )
              .then((res) => {
                let response = JSON.parse(JSON.stringify(res));
                if (response.data.code == 200) {
                  this.service.showSuccess("Assets saved successfully");
                  localStorage.removeItem("assetBatchID");
                  this.router.navigate(["/device-reports"]);
                }
              })
              .catch((err) => {
                this.service.showError("Error saving powertrain!");
                console.log(err);
              });
          }
          console.log(this.powertrainSensors);
        }
      });
    }
  }

  saveDraft() {
    this.spinner.show();
    let _imgId = null;
    if (this.uploadSuccess) {
      _imgId = this.id;
    } else if (this._imageId != null) {
      _imgId = this._imageId;
    }

    if (this.invalidFrequencyValue) {
      return this.service.showError("Invalid sensor data publish frequency.");
    }
    if (this.variableRPMToggle !== "fixed") {
      if (!this.uForm.value.min_rated_rpm) {
        return this.service.showError("minimum rated rpm can't be empty!");
      } else if (!this.uForm.value.max_rated_rpm) {
        return this.service.showError("maximum rated rpm can't be empty!");
      } else {
        if (
          parseInt(this.uForm.value.min_rated_rpm) <=
          parseInt(this.uForm.value.max_rated_rpm)
        ) {
          /********************************* */
        } else {
          return this.service.showError(
            "maximum rpm must be greater than minimum rpm."
          );
        }
      }
    }
    if (this.ivInventoryMsg !== "") {
      return this.service.showError("Please check configurations again!");
    }
    if (this.uForm.value.application_id != undefined) {
      localStorage.setItem("applicationID", this.uForm.value.application_id);
    }
    if (this.uForm.value.site_id != undefined) {
      localStorage.setItem("siteID", this.uForm.value.site_id);
    }
    if (this.uForm.value.name != undefined) {
      localStorage.setItem("assetName", this.uForm.value.name);
    }
    if (JSON.parse(this.uForm.value.cloud_pushrate_anomaly) < 1) {
      return this.service.showError(
        "Cloud push rate anomaly value can't be less than 1."
      );
    }
    if (
      JSON.parse(this.uForm.value.cloud_pushrate_high) <
      JSON.parse(this.uForm.value.data_frequency)
    ) {
      return this.service.showError(
        "Cloud push rate high must be greater than sensor data publish frequency."
      );
    }

    if (this.showEditUsertxt === "Create Asset" || "Update Powertrain") {
      // if(this.selectedAssetType === 'INDUCTION_MOTOR' || this.selectedAssetType === 'DC_MOTOR' || this.selectedAssetType === 'SYNCHRONOUS_MOTOR' || this.selectedAssetType === 'ALTERNATOR'){
      //   this.selectedAssetType = 'MOTOR';
      // }
      if (this.selectedAssetType === "MOTOR") {
        this.subAssetType =
          this.powertrainSensors[this.currentSensorIndex].subType;
      }
      this.powertrainSensors[this.currentSensorIndex].mac_address =
        this.uForm.value.mac_address;
      this.powertrainSensors[this.currentSensorIndex].motor_serial =
        this.uForm.value.motor_serial;
      this.currentFormCount += 1;
      console.log("BATCH ID FROM TABLE_DATA: " + this.subsystem_table_data.subsystem_uuid);
      const body = {
        asset_batch_id: this.subsystem_table_data.subsystem_uuid
          ? this.subsystem_table_data.subsystem_uuid
          : localStorage.getItem("assetBatchID"),
        user_id: this.userID,
        device_name: this.uForm.value.device_name,
        device_sno:
          this.powertrainSensors[this.currentSensorIndex].sensor_number,
        axial: this.uForm.value.Axial,
        radial: this.uForm.value.Vertical,
        tangential: this.uForm.value.Horizontal,
        template_id: "",
        line_current: this.uForm.value.line_current,
        accelro_odr: this.uForm.value.accelro_odr,
        accelro_odr_high: this.uForm.value.accelro_odr_high,
        cloud_pushrate_high: this.uForm.value.cloud_pushrate_high,
        cloud_pushrate_anomaly: this.uForm.value.cloud_pushrate_anomaly,
        cloud_anomaly_counter: this.uForm.value.cloud_anomaly_counter,
        device_type_id: this.deviceTypeID,
        admin_id: this.adminID,
        asset_on_off_status: this.onOffStatus,
        motor_make: this.uForm.value.motor_make,
        equipment_location: this.uForm.value.equipment_location,
        insulation_class: this.uForm.value.insulation_class,
        frame: this.uForm.value.frame == "" ? null : this.uForm.value.frame,
        frame_unit: "L",
        asset_type:
          this.selectedAssetType === "INDUCTION_MOTOR" ||
          this.selectedAssetType === "DC_MOTOR" ||
          this.selectedAssetType === "SYNCHRONOUS_MOTOR" ||
          this.selectedAssetType === "ALTERNATOR"
            ? "MOTOR"
            : this.selectedAssetType,
        subtype: this.subAssetType,
        rated_ambient_temprature: this.uForm.value.rated_ambient_temprature,
        rated_ambient_temprature_unit: this.uForm.value.temperature_sy,
        power_factor:
          this.uForm.value.power_factor == ""
            ? null
            : this.uForm.value.power_factor,
        rated_power: this.uForm.value.rated_power,
        rated_power_unit: this.uForm.value.power_unit,
        rated_rpm: this.uForm.value.rated_rpm,
        max_rated_rpm:
          this.variableRPMToggle === "fixed"
            ? 0
            : this.uForm.value.max_rated_rpm,
        min_rated_rpm:
          this.variableRPMToggle === "fixed"
            ? this.uForm.value.rated_rpm
            : this.uForm.value.min_rated_rpm,
        rpm_toggle: this.uForm.value.rpm_toggle,
        percentage_efficiency: this.uForm.value.percentage_efficiency,
        rated_voltage: this.uForm.value.rated_voltage,
        motor_serial_no: this.uForm.value.motor_serial,
        line_frequency: this.uForm.value.line_frequency,
        duty: this.uForm.value.duty,
        inventory_id: this.InventoryIDValue,
        mac_address: this.uForm.value.mac_address,
        site_id: JSON.parse(localStorage.getItem("siteID")),
        application_id: JSON.parse(localStorage.getItem("applicationID")),
        data_frequency: this.uForm.value.data_frequency,
        config_pull_rate: this.uForm.value.config_pull_rate,
        cloud_push_rate: this.uForm.value.cloud_push_rate,
        sensor_scan_rate: this.uForm.value.sensor_scan_rate,
        file_comparison_threshold_percentage:
          this.uForm.value.file_comparison_threshold_percentage,
        winding_rtd: this.uForm.value.winding_rtd,
        wifi_user: this.uForm.value.wifi_user,
        wifi_password: this.uForm.value.wifi_password,
        connectivity_type: this.uForm.value.connectivity_type,
        ip: this.uForm.value.ip,
        port: this.uForm.value.port,
        proxy_username: this.uForm.value.proxy_username,
        proxy_password: this.uForm.value.proxy_password,
        name: localStorage.getItem("assetName"),
        de_bearing_number: this.uForm.value.de_bearing_number,
        nde_bearing_number: this.uForm.value.nde_bearing_number,
        nde_bearing: this.uForm.value.nde_bearing,
        de_bearing: this.uForm.value.de_bearing,
        gear_make: this.uForm.value.gear_make,
        gear_type_one: this.uForm.value.gear_one,
        gear_type_two: this.uForm.value.gear_two,
        outer_gear_rpm: this.uForm.value.outer_gear_rpm,
        outer_gear_bearing_number: this.uForm.value.outer_gear_bearing_number,
        pinion_bearing_number: this.uForm.value.pinion_bearing_number,
        pinion_gear_teeth: this.uForm.value.pinion_gear_teeth,
        pinion_gear_rpm: this.uForm.value.pinion_gear_rpm,
        outer_gear_number: this.uForm.value.outer_gear_number,
        outer_teeth: this.uForm.value.outer_teeth,
        outer_bearing_no: this.uForm.value.outer_bearing_no,
        gmf_data: this.uForm.value.gmf_data,
        deb_pinion_number: this.uForm.value.deb_pinion_number || "NA",
        ndeb_pinion_number: this.uForm.value.ndeb_pinion_number || "NA",
        belt_length: this.uForm.value.belt_length,
        belt_number: this.uForm.value.belt_number,
        db_shart_centers: this.uForm.value.db_shart_centers,
        driven_pulley_diameter: this.uForm.value.driven_pulley_diameter,
        driver_pulley_diameter: this.uForm.value.driver_pulley_diameter,
        drive_type: this.driveType,
        no_of_blades: this.uForm.value.no_of_blades,
        device_config_update_interval:
          this.uForm.value.device_config_update_interval,
        vs_scan_rate: this.uForm.value.vs_scan_rate,
        machine_threshold: this.uForm.value.machine_threshold_status,
        vs_resolution_mode: this.uForm.value.vs_resolution_mode,
        machine_threshold_status: this.uForm.value.machine_threshold_status,
        accelero_FS: this.uForm.value.accelero_FS,
        sensor_mounting_axis_option:
          this.uForm.value.sensor_mounting_axis_option,
        rtd_one: this.uForm.value.rtd_one,
        rtd_two: this.uForm.value.rtd_two,
        rtd_three: this.uForm.value.rtd_three,
        audible_adjustment: this.uForm.value.audible_adjustment,
        poles: this.uForm.value.polePairNumber,
        dctype: this.uForm.value.dc_type,
        subsystem_id: null,
        powertrain:1
      };
      // body["asset_selector"] = this.currentSensorIndex==0?"MASTER":"CHILD";
      if (_imgId != null) {
        body["image_id"] = _imgId;
      }

      body["asset_selector"] =
        this.powertrainSensors[this.currentSensorIndex].assetMarker;
      body["powertrain"]=1;
      if (this.fromDataArray.length === 0) {
        this.fromDataArray.push({ body });
      } else {
        this.fromDataArray.push({ body });
      }
      this.allDevices = this.allDevices.filter(
        (item) => item.mac_address !== this.uForm.value.mac_address
      );
      this.filterdOptions = this.filterdOptions.filter(
        (item) => item.mac_address !== this.uForm.value.mac_address
      );
      this.variableRPMToggle = "fixed";

      this.currentSensorIndex++;
      console.log(this.currentSensorIndex, this.totalSensors);

      if (this.currentSensorIndex == this.totalSensors - 1) {
        this.showSavebtn = true;
      }
      if (this.currentSensorIndex == this.totalSensors) {
      } else {
        //Change form type and asset type subtype for next sensor
        this.selectedAssetType =
          this.powertrainSensors[this.currentSensorIndex].assetType;
        console.log("NEW ASSET TYPE", this.selectedAssetType);
        if (this.selectedAssetType == "GEAR") {
          this.selectedAssetTypeRadio = "GEAR";
          this.subAssetType = "";
        } else if (this.selectedAssetType == "MOTOR") {
          this.selectedAssetTypeRadio =
            this.powertrainSensors[this.currentSensorIndex].subType;
          this.subAssetType =
            this.powertrainSensors[this.currentSensorIndex].subType;
        } else {
          this.subAssetType = "";
          this.selectedAssetTypeRadio =
            this.powertrainSensors[this.currentSensorIndex].assetType;
        }
        // To change gear form or asset form on changing asset
        this.onAssetChangeValue(this.selectedAssetType, "");

        //values passed in params not used
        this.nextSensor(
          this.currentSensorIndex,
          this.currentSensorIndex + 1,
          -1,
          this.uForm.value.mac_address
        );
      }
    }
  }

  //CHANGE FORM ON CLICKING CONTINUE
  onAssetChangeValue(selection, val) {
    console.log("NEW ASSET TYPE", selection);
    this.selectedAssetType = selection;
    // if (val === 'click_event') {
    //   this.cancelRadioPress(selection);
    // } else {
    switch (this.selectedAssetType) {
      case "MOTOR":
        this.assetDetailForm = true;
        this.gearDetailForm = false;
        break;
      case "GEAR":
        this.assetDetailForm = false;
        this.gearDetailForm = true;
        this.gearFormController();
        break;
      case "FAN_BLOWER":
        this.assetDetailForm = true;
        this.gearDetailForm = false;
        break;
      case "PUMP":
        this.assetDetailForm = true;
        this.gearDetailForm = false;
        break;
      case "COMPRESSOR":
        this.assetDetailForm = true;
        this.gearDetailForm = false;
        break;
      case "JOURNAL_BEARING":
        this.assetDetailForm = true;
        this.gearDetailForm = false;
        break;
    }
    //}
  }

  //On Mac address select
  selectedOption() {
    this.ivInventoryMsg = "";
  }

  public gearFormController() {
    this.uForm = this.formBuilder.group({
      motor_make: new FormControl(""),
      equipment_location: new FormControl(""),
      cloud_pushrate_high: new FormControl(60, [Validators.required]),
      cloud_pushrate_anomaly: new FormControl(180, [Validators.required]),
      cloud_anomaly_counter: new FormControl(1, [Validators.required]),
      accelro_odr_high: new FormControl("NORMAL"),
      accelro_odr: new FormControl("NORMAL"),
      frame: new FormControl(""),
      line_current: new FormControl("0"),
      rated_ambient_temprature: new FormControl("0"),
      insulation_class: new FormControl(""),
      motor_serial: new FormControl("", [
        Validators.required,
        this.noWhitespaceValidator,
      ]),
      rated_power: new FormControl("", Validators.required),
      rated_rpm: new FormControl(""),
      max_rated_rpm: new FormControl(""),
      device_name: new FormControl("", [
        Validators.required,
        this.noWhitespaceValidator,
      ]),
      min_rated_rpm: new FormControl(""),
      rated_voltage: new FormControl(""),
      power_factor: new FormControl(""),
      temperature_sy: new FormControl(""),
      power_unit: new FormControl("KW"),
      rpm_toggle: new FormControl("fixed"),
      site_id: new FormControl("", Validators.required),
      application_id: new FormControl("", Validators.required),
      mac_address: new FormControl("", [
        Validators.required,
        this.noWhitespaceValidator,
      ]),
      duty: new FormControl(""),
      device_config_update_interval: new FormControl(60),
      vs_scan_rate: new FormControl(15, Validators.required),
      machine_threshold_status: new FormControl(0.5, [Validators.required]),
      accelero_FS: new FormControl(8, [Validators.required]),
      vs_resolution_mode: new FormControl("NORMAL"),

      sensor_mounting_axis_option: new FormControl("PARALLEL_SIDE"),
      rtd_one: new FormControl("MS"),
      rtd_two: new FormControl("DE"),
      rtd_three: new FormControl("NDE"),
      percentage_efficiency: new FormControl(""),
      // line_frequency: new FormControl("", [Validators.required]),
      data_frequency: new FormControl(15, [Validators.required]),
      config_pull_rate: new FormControl(60),
      cloud_push_rate: new FormControl(60),
      sensor_scan_rate: new FormControl(15),
      file_comparison_threshold_percentage: new FormControl(60),
      winding_rtd: new FormControl("0"),
      connectivity_type: new FormControl("wifi"),
      wifi_user: new FormControl("EnerticsWiFi", [Validators.required]),
      wifi_password: new FormControl("Enertics"),
      ip: new FormControl(""),
      port: new FormControl(""),
      proxy_username: new FormControl(""),
      proxy_password: new FormControl(""),
      name: new FormControl("", [
        Validators.required,
        this.noWhitespaceValidator,
      ]),
      de_bearing_number: new FormControl({ value: "NA", disabled: true }),
      nde_bearing_number: new FormControl({ value: "NA", disabled: true }),
      nde_bearing: new FormControl("0"),
      de_bearing: new FormControl("0"),
      gear_make: new FormControl(""),
      gear_type_one: new FormControl(""),
      gear_type_two: new FormControl(""),
      outer_gear_rpm: new FormControl("", [
        Validators.required,
        this.noWhitespaceValidator,
      ]),
      outer_gear_bearing_number: new FormControl(""),
      pinion_gear_teeth: new FormControl(""),
      pinion_gear_rpm: new FormControl("", [
        Validators.required,
        this.noWhitespaceValidator,
      ]),
      outer_gear_number: new FormControl(""),
      outer_teeth: new FormControl(""),
      outer_bearing_no: this.formBuilder.array([]),
      deb_pinion_number: new FormControl("NA", Validators.required),
      ndeb_pinion_number: new FormControl("NA", Validators.required),
      gear_count: new FormControl(1, Validators.required),
      gmf_data: this.formBuilder.array([]),
      GMF_unit: new FormControl("no"),
      GMFdrop: new FormControl(Validators.required),
      no_of_blades: new FormControl(0),
      bearing_radio: new FormControl("off"),
      output_bearing_radio: new FormControl("no"),
      audible_adjustment: new FormControl([0]),
      polePairNumber: new FormControl([0]),
      dc_type: new FormControl(""),
    });
    //On creating asset gear form select sleeve bearing and diabled both dropdowns
    this.uForm.get("deb_pinion_number").disable();
    this.uForm.get("ndeb_pinion_number").disable();
    this.uForm.patchValue({
      deb_pinion_number: 'N/A',
      ndeb_pinion_number: 'N/A',
    });

    if (this.showEditUsertxt === "Create Asset" || 'Update Powertrain') {
      this.outer_bearing_no().push(
        this.formBuilder.group({
          ndeb_outer: new FormControl(
            { value: "N/A", disabled: true },
            Validators.required
          ),
          deb_outer: new FormControl(
            { value: "N/A", disabled: true },
            Validators.required
          ),
        })
      );
    }
  }

  outer_bearing_no(): FormArray {
    return this.uForm.get("outer_bearing_no") as FormArray;
  }
  gmf_data(): FormArray {
    return this.uForm.get("gmf_data") as FormArray;
  }

  selectNumberOfGear(event: any) {
    //console.log(event);
    let addFields =
      parseInt(event) - parseInt(this.outer_bearing_no().value.length);
    if (this.showEditUsertxt === "Create Asset"||'Update Powertrain') {
      //console.log("yes");
      if (parseInt(event) !== 0) {
        for (var n = 0; n < addFields; n++) {
          this.outer_bearing_no().push(this.newgroup_name());
        }
        this.uForm.controls["gear_count"].setValue(
          this.outer_bearing_no().value.length
        );
        if (this.outer_bearing_no().value.length > parseInt(event)) {
          this.service.showError("Remove existing value first.");
          this.uForm.controls["gear_count"].setValue(
            this.outer_bearing_no().value.length
          );
        }
      } else {
        this.uForm.controls["gear_count"].setValue(1);
      }
    } else {
      if (parseInt(event) !== 0) {
        if (this.outer_bearing_no().value.length > parseInt(event)) {
          this.service.showError("Remove existing value first.");
          this.uForm.controls["gear_count"].setValue(
            this.outer_bearing_no().value.length
          );
        } else {
          for (let n = 0; n < addFields; n++) {
            this.outer_bearing_no().push(this.newgroup_name());
          }
        }
      } else {
        this.uForm.controls["gear_count"].setValue(1);
      }
    }
  }
  newgroup_name(): FormGroup {
    return this.formBuilder.group({
      ndeb_outer: new FormControl("", Validators.required),
      deb_outer: new FormControl("", Validators.required),
    });
  }
  selectGMF(val: any) {
    if (val == "yes") {
      this.GMFvisible = true;
    } else {
      this.GMFvisible = false;
    }
  }
  selectNumberOfGMF(event: any) {
    let addinput = [];
    let addFields = parseInt(event) - parseInt(this.gmf_data().value.length);
    if (this.showEditUsertxt === "Create Asset"||"Update Powertrain") {
      if (parseInt(event) !== 0) {
        for (let i = 0; i < addFields; i++) {
          this.gmf_data().push(this.newgroup_GMFname());
        }
        this.uForm.controls["GMFdrop"].setValue(this.gmf_data().value.length);
        if (this.gmf_data().value.length > parseInt(event)) {
          this.service.showError("Remove existing value first.");
          this.uForm.controls["GMFdrop"].setValue(this.gmf_data().value.length);
        }
      } else {
        this.uForm.controls["GMFdrop"].setValue(1);
      }
    } else {
      if (parseInt(event) !== 0) {
        if (this.gmf_data().value.length > parseInt(event)) {
          this.service.showError("Remove existing value first.");
          this.uForm.controls["GMFdrop"].setValue(this.gmf_data().value.length);
        } else {
          for (let n = 0; n < addFields; n++) {
            this.gmf_data().push(this.newgroup_GMFname());
          }
        }
      } else {
        this.uForm.controls["GMFdrop"].setValue(1);
      }
    }
  }

  newgroup_GMFname(): FormGroup {
    return this.formBuilder.group({
      gmfName: new FormControl("", [Validators.required]),
      gmfNumber: new FormControl("", [Validators.required]),
    });
  }

  removeFileds(index, val) {
    if (this.showEditUsertxt !== "Create Asset" || "Update Powertrain") {
      if (val == "gmf") {
        for (let i = 0; i < this.gmf_data().value.length; i++) {
          if (this.gmf_data().value[i] === undefined) {
            if (i === index) {
              this.gmf_data().removeAt(index);
              this.uForm.controls["GMFdrop"].setValue(
                this.gmf_data().value.length
              );
            }
          } else {
            if (i === index) {
              this.service.showSuccess("deleted successfully");
              this.gmf_data().removeAt(index);
              this.uForm.controls["GMFdrop"].setValue(
                this.gmf_data().value.length
              );
            }
          }
        }
      } else {
        for (let n = 0; n < this.outer_bearing_no().value.length; n++) {
          if (this.outer_bearing_no().value[n].id === undefined) {
            if (n === index) {
              this.outer_bearing_no().removeAt(index);
              this.uForm.controls["gear_count"].setValue(
                this.outer_bearing_no().value.length
              );
            }
          } else {
            if (n === index) {
              this.service
                .deleteInfo(
                  this.updateAssetsUrl +
                    "/outer/remove/" +
                    this.outer_bearing_no().value[index].id
                )
                .then((res) => {
                  if (
                    JSON.parse(JSON.stringify(res)).data.message === "deleted"
                  ) {
                    this.service.showSuccess("deleted successfully");
                    this.outer_bearing_no().removeAt(index);
                    this.uForm.controls["gear_count"].setValue(
                      this.outer_bearing_no().value.length
                    );
                  }
                });
            }
          }
        }
      }
    } else {
      if (val == "gmf") {
        this.gmf_data().removeAt(index);
        this.uForm.controls["GMFdrop"].setValue(index);
      } else {
        this.outer_bearing_no().removeAt(index);
        this.uForm.controls["gear_count"].setValue(
          this.outer_bearing_no().value.length
        );
      }
    }
  }
  outputBearingButton(value: any) {
    this.outputbearingVal = value;
    if (this.outputbearingVal == "yes") {
      this.uForm.get("outer_bearing_no").at(0).get("ndeb_outer").enable();
      this.uForm.get("outer_bearing_no").at(0).get("deb_outer").enable();
      this.uForm.get("outer_bearing_no").at(0).patchValue({
        ndeb_outer: this.bearingNumbers[2].bearing_number,
        deb_outer: this.bearingNumbers[2].bearing_number,
      });
    } else {
      this.uForm.get("outer_bearing_no").at(0).patchValue({
        ndeb_outer: this.bearingNumbers[0].bearing_number,
        deb_outer: this.bearingNumbers[0].bearing_number,
      });
      this.uForm.get("outer_bearing_no").at(0).get("ndeb_outer").disable();
      this.uForm.get("outer_bearing_no").at(0).get("deb_outer").disable();
    }
  }

  public noWhitespaceValidator(control: FormControl) {
    const isWhitespace = (control.value || "").trim().length === 0;
    const isValid = !isWhitespace;
    return isValid ? null : { whitespace: true };
  }

  nextSensor(
    currentId: number,
    nextId: number,
    asset_id: number,
    mac_address: string
  ) {
    this.spinner.show();
    setTimeout(() => {
      this.gotoTop();
      this.resetMotorInputFields();
      this.spinner.hide();
    }, 2000);
  }

  gotoTop() {
    this.divToScroll.nativeElement.scrollTop = 30;
  }

  resetMotorInputFields() {
    this.uForm.controls["site_id"].setValue(
      JSON.parse(localStorage.getItem("siteID"))
    );
    this.uForm.controls["application_id"].setValue(
      JSON.parse(localStorage.getItem("applicationID"))
    );
    this.uForm.controls["name"].setValue(localStorage.getItem("assetName"));
    this.uForm.controls["name"].disable();
    this.uForm.controls["application_id"].disable();
    this.uForm.controls["site_id"].disable();
    this.uForm.controls["mac_address"].reset();
    this.uForm.controls["motor_serial"].reset();
    this.uForm.controls["rated_ambient_temprature"].reset();
    this.uForm.controls["device_name"].reset();
    this.uForm.controls["rated_power"].reset();
    this.uForm.controls["insulation_class"];

    return;
  }

  cancelButtonPress() {
    if (this.showEditUsertxt === "Create Asset"||"Update Powertrain") {
      const dialogRef = this.dialog.open(DialogOverviewExampleDialogComponent, {
        width: "400px",
        height: "auto",
        data: {
          type: "discard-changes-dialog-box",
          typeOf: "asset",
        },
      });
      dialogRef.afterClosed().subscribe((result) => {
        if (result !== undefined) {
          this.router.navigate(["device-reports"]);
        }
      });
    }
  }

  upload(files: any) {
    if (files[0].name !== undefined && files[0].name === "") {
      this.fileName = "";
    } else {
      this.showCancelBtn = true;
      this.fileName = files[0].name;
      if (this.showEditUsertxt !== "Create Asset"||"Update Asset") {
        var reader = new FileReader();
        this.imagePath = files;
        reader.readAsDataURL(files[0]);
        reader.onload = (_event) => {
          this._imgUrl = reader.result;
        };
        this.uploader.uploadAll();
        this.uploader.onProgressItem = (progress: any) => {
          this.percentDone = progress["progress"];
          this.pic = true;
        };
      } else {
        this.pic = true;
        var reader = new FileReader();
        this.imagePath = files;
        reader.readAsDataURL(files[0]);
        reader.onload = (_event) => {
          this._imgUrl = reader.result;
        };
      }
    }
  }
}
